<template>
  <page>
    <template #content>
      <SubTopBar/>
    <v-breadcrumbs
      :items="bcItems"
      divider=">"
      class="mt-1"
      large
      />
      <v-form ref="form" v-model="valid">
        <v-col cols="12">
          <v-row>
            <v-text-field
              v-model="label"
              outlined
              dense
              :rules="[global.rules.requiredField, global.rules.minLength]"
              name="label"
              label="Label *"
              :disabled="updateApiKey"
            />
          </v-row>
          <v-row>
            <v-text-field
              v-model="callbackURL"
              dense
              outlined
              name="url"
              label="Callback URL"
            />
          </v-row>
          <v-row>
            <v-text-field
              v-model="secret"
              dense
              outlined
              type="password"
              name="secret"
              disabled
              label="Secret"
            />
            <v-btn
              icon
              v-clipboard:copy=secret
              v-clipboard:success="handleCopyStatus"
              >
              <v-icon>mdi-content-copy</v-icon>
            </v-btn>
          </v-row>
          <v-row>
            <v-checkbox
            class="mt-n2"
              v-model="clientCredentialsGrantType"
              label="May be used in client credentials grant type"
            />
          </v-row>
          <v-row>
            <v-btn :disabled="!valid" color="primary" @click="createKey" v-if="!editLabel">Create key</v-btn>
            <v-btn :disabled="!valid" color="primary" @click="updateKey" v-if="editLabel">Update key</v-btn>
            <v-btn depressed text @click="close">cancel</v-btn>
          </v-row>
        </v-col>
      </v-form>
    </template>
  </page>
</template>

<script>
const Iam = require('iam')
import Strings from "./Strings.js"

export default {
  data() {
    return {
      label: "",
      callbackURL: "",
      clientCredentialsGrantType: false,
      secret: "",
      valid: false,
    }
  },
  computed: {
    organization: function () { return this.$route.params.organization },
    editLabel: function () { return this.$route.params.label },
    updateApiKey: function () { return "undefined" !== typeof this.$route.params.label },
    bcItems: function () {
      return [
        {},
        {
          text: "Organizations",
          disabled: false,
          exact: true,
          to: {name: 'Organizations'}
        },
        {
          text: `${this.$route.params.organization}`,
          disabled: false,
          exact: true,
          to: {name: 'OrganizationManagement'} 
          
        },
        {
          text: "API access keys",
          disabled: false,
          exact: true,
          to: {name: 'OrganizationApiAccessKeys'} 
          
        },
        {
          text: `${this.$route.meta.bcText}`,
          disabled: false,
          exact: true,
          href: `${this.$route.path}`
        },
      ]}
  },
  created: function (){
    if (this.editLabel) {
      this.$api.getOrganizationAPIKey(this.editLabel, this.organization, this.callBack(
        response => {
          this.label = response.label
          this.callbackURL = response.callbackURL
          this.clientCredentialsGrantType = response.clientCredentialsGrantType
          this.secret = response.secret
        }
      ))
    }
  },
  methods: {
    createKey: function () {
      if (!this.$refs.form.validate()) return
      const body = new Iam.OrganizationAPIKey()
      body.label = this.label
      body.callbackURL = this.callbackURL
      body.clientCredentialsGrantType = this.clientCredentialsGrantType
      this.$api.createNewOrganizationAPIKey(body, this.organization, this.callBack(
        response => {
          this.secret = response.secret
          this.alert("info", Strings(this, "successfully_add_api_key"), undefined, undefined, ()=> {
            this.$router.replace({ name: "OrganizationEditAPIKey", params: { organization: this.organization, label: this.label }})
          })
        }))
    },
    updateKey: function () {
      if (!this.$refs.form.validate()) return
      const body = new Iam.OrganizationAPIKey()
      body.label = this.label
      body.callbackURL = this.callbackURL
      body.clientCredentialsGrantType = this.clientCredentialsGrantType
      body.secret = this.secret
      this.$api.updateOrganizationAPIKey(body, this.label, this.organization, this.callBack(this.close))
    },
    handleCopyStatus() {
      this.alert("info", Strings(this, "successfully_copy_api_key"))
    }
  }
}
</script>